<script lang="ts">
  import { t } from '$lib/translations';
  import ServicesSectionItem from './ServicesSectionItem.svelte';
  export let servicesPrices: Record<string, string>;
  const services = [
    {
      title: $t('servicesSection.shuttle_title'),
      from: $t('servicesSection.from'),
      price: servicesPrices['shuttle'] || '7,00€',
      content: [$t('servicesSection.shuttle_content1'), $t('servicesSection.shuttle_content2'), $t('servicesSection.shuttle_content3'), $t('servicesSection.shuttle_content4')],
      image: '/services-prices/shuttle.png',
    },
    {
      title: $t('servicesSection.private_title'),
      from: $t('servicesSection.from'),
      price:servicesPrices['private'] || '42,91€',
      content: [$t('servicesSection.private_content1'), $t('servicesSection.private_content2'), $t('servicesSection.private_content3'), $t('servicesSection.private_content4')],
      image: '/services-prices/private.png',
    },
    {
      title: $t('servicesSection.wheelchair_title'),
      from: $t('servicesSection.from'),
      price:servicesPrices['wheelchair'] || '42,91€',
      content: [$t('servicesSection.wheelchair_content1'), $t('servicesSection.wheelchair_content2')],
      image: '/services-prices/wheelchair.png',
    },
    {
      title: $t('servicesSection.luxury_title'),
      from: $t('servicesSection.from'),
      price: servicesPrices['luxury'] || '56,82€',
      content: [$t('servicesSection.luxury_content1'), $t('servicesSection.luxury_content2'), $t('servicesSection.luxury_content3'), $t('servicesSection.luxury_content4')],
      image: '/services-prices/luxury.png',
    },
  ];
</script>
<h1 class="text-5xl  font-bold">
  {$t('servicesSection.title')}
</h1>
<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-[80%] mx-auto">
  {#each services as item}
    <ServicesSectionItem
      title={item.title}
      from={item.from}
      content={item.content}
      image={item.image}
      price={item.price}
    />
  {/each}
</div>
<span class='text-[0.5rem] mb-2'>{$t('servicesSection.footer')}</span>